import RolesManager from './RolesManager'

export default RolesManager
